import { tokens } from './tokens';

export const spacing = tokens.spacing;

export type SpacingScale = keyof typeof spacing;
export type SpacingValue = (typeof spacing)[SpacingScale];

export const getSpacing = (...values: SpacingScale[]): number => {
  return values.reduce((acc, value) => acc + spacing[value], 0);
};

export const spacingMultiplier = (scale: SpacingScale, multiplier: number): number => {
  return spacing[scale] * multiplier;
};

export const createSpacingObject = (
  top?: SpacingScale,
  right?: SpacingScale,
  bottom?: SpacingScale,
  left?: SpacingScale,
) => {
  return {
    paddingTop: top ? spacing[top] : undefined,
    paddingRight: right ? spacing[right] : undefined,
    paddingBottom: bottom ? spacing[bottom] : undefined,
    paddingLeft: left ? spacing[left] : undefined,
  };
};

export const createMarginObject = (
  top?: SpacingScale,
  right?: SpacingScale,
  bottom?: SpacingScale,
  left?: SpacingScale,
) => {
  return {
    marginTop: top ? spacing[top] : undefined,
    marginRight: right ? spacing[right] : undefined,
    marginBottom: bottom ? spacing[bottom] : undefined,
    marginLeft: left ? spacing[left] : undefined,
  };
};

export const createPaddingShorthand = (vertical?: SpacingScale, horizontal?: SpacingScale) => {
  return {
    paddingVertical: vertical ? spacing[vertical] : undefined,
    paddingHorizontal: horizontal ? spacing[horizontal] : undefined,
  };
};

export const createMarginShorthand = (vertical?: SpacingScale, horizontal?: SpacingScale) => {
  return {
    marginVertical: vertical ? spacing[vertical] : undefined,
    marginHorizontal: horizontal ? spacing[horizontal] : undefined,
  };
};
